/**
 * Converted from: https://code.amazon.com/packages/HandshakePainterAssets/blobs/mainline/--/base/src/js/common.js
 */
export var Platform;
(function (Platform) {
    Platform["ANDROID"] = "android";
    Platform["IOS"] = "ios";
    Platform["UNKNOWN"] = "unknown";
})(Platform || (Platform = {}));
export var Client;
(function (Client) {
    Client["FACEBOOK"] = "facebook";
    Client["INSTAGRAM"] = "instagram";
    Client["SNAPCHAT"] = "snapchat";
    Client["UNKNOWN"] = "unknown";
})(Client || (Client = {}));
export const getMobileOperatingSystem = () => {
    const userAgent = navigator.userAgent;
    if (/android/i.test(userAgent)) {
        return Platform.ANDROID;
    }
    // @ts-expect-error Apparently MSStream doesn't exist but this is a copy/pasta from V1
    if (/ipad|iphone|ipod/i.test(userAgent) && !window.MSStream) {
        return Platform.IOS;
    }
    return Platform.UNKNOWN;
};
export const getClient = () => {
    const userAgent = navigator.userAgent;
    if (/instagram/i.test(userAgent)) {
        return Client.INSTAGRAM;
    }
    if (/fb_iab|fbios/i.test(userAgent)) {
        return Client.FACEBOOK;
    }
    if (/snapchat/i.test(userAgent)) {
        return Client.SNAPCHAT;
    }
    return Client.UNKNOWN;
};
